import { Mail, ArrowRight } from "lucide-react";

/**
 * EmailLookupForm - Initial email input to check if user exists
 */
export default function EmailLookupForm({ 
  email, 
  setEmail, 
  onSubmit, 
  loading 
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    onSubmit(e);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div className="relative">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-brand/20 focus:border-brand"
          data-testid="modal-email-input"
          required
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        className="w-full py-3 bg-brand text-white rounded-xl font-medium hover:bg-brand-dark transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
        data-testid="modal-continue-btn"
      >
        {loading ? "Checking..." : "Continue with Email"}
        {!loading && <ArrowRight className="w-4 h-4" />}
      </button>
    </form>
  );
}
